import SubcategoryPage from '@/components/template/SubcategoryPage';

const GlineniUmivalniki = () => {
  const products = [
    {
      title: "Glinen Umivalnik Rustikalen",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/umivalniki/glineni/rustikalen"
    },
    {
      title: "Glinen Umivalnik Organsko",
      imageSrc: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&q=80",
      url: "/umivalniki/glineni/organsko"
    },
    {
      title: "Glinen Umivalnik Pramenitni",
      imageSrc: "https://images.unsplash.com/photo-1600566752610-111d521cf1de?auto=format&fit=crop&q=80",
      url: "/umivalniki/glineni/pramenitni"
    },
    {
      title: "Glinen Umivalnik Tradicionalen",
      imageSrc: "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80",
      url: "/umivalniki/glineni/tradicionalen"
    },
    {
      title: "Glinen Umivalnik Handmade",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/umivalniki/glineni/handmade"
    },
    {
      title: "Glinen Umivalnik Premium",
      imageSrc: "https://images.unsplash.com/photo-1600566752427-25ef8fb4e018?auto=format&fit=crop&q=80",
      url: "/umivalniki/glineni/premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Glineni Umivalniki"
      description="Odkrijte našo zbirko ročno izdelanih glinenih umivalnikov, ki prinašajo rustikalno toplino in avtentičnost v vsako kopalnico. Vsak umivalnik je unikaten z naravnimi teksturami in trajnostno izdelavo."
      heroImage="https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default GlineniUmivalniki;